
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "box": "box-77daeb46",
    "center": "center-77daeb46",
    "middle": "middle-77daeb46",
    "no-wrap": "no-wrap-77daeb46",
    "fit-width": "fit-width-77daeb46",
    "fit-height": "fit-height-77daeb46",
    "fit-both": "fit-both-77daeb46",
    "noWrap": "no-wrap-77daeb46",
    "fitWidth": "fit-width-77daeb46",
    "fitHeight": "fit-height-77daeb46",
    "fitBoth": "fit-both-77daeb46"
};
exports.styleSource = ".box-77daeb46{position:relative;box-sizing:border-box}.center-77daeb46{display:flex;flex-direction:column;align-items:center}.middle-77daeb46{display:flex;flex-direction:column;justify-content:center}.no-wrap-77daeb46{white-space:nowrap}.fit-width-77daeb46{width:100%}.fit-height-77daeb46{height:100%}.fit-both-77daeb46{width:100%;height:100%}";
exports.default = exports.styles;
            
module.moduleType = "style";
